import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_10651_32800)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.49272 5.62704H6.48716C6.08905 5.62704 5.83554 5.4752 5.72005 5.17152C5.60457 4.86784 5.6947 4.58196 6.01206 4.31015L10.7443 0.254476C11.1386 -0.0838873 11.455 -0.0857619 11.8466 0.254476L16.6004 4.31858C16.9018 4.57727 16.9947 4.85846 16.8821 5.16215C16.7694 5.46583 16.5159 5.62329 16.1196 5.62423H14.115V5.87824C14.115 6.49498 14.115 7.11172 14.115 7.72939C14.122 7.78933 14.1099 7.84995 14.0804 7.90262C14.0509 7.9553 14.0055 7.99734 13.9507 8.02277C11.2278 9.61616 9.7997 11.9866 9.91801 15.1462C10.025 18.0087 11.4513 20.1467 13.9235 21.5835C13.9853 21.6105 14.0369 21.6565 14.0707 21.7149C14.1045 21.7732 14.1187 21.8409 14.1113 21.9078C14.1009 22.368 14.1113 22.8292 14.1056 23.2894C14.1076 23.3816 14.0911 23.4734 14.057 23.5591C14.0229 23.6448 13.9719 23.7229 13.907 23.7886C13.8421 23.8543 13.7647 23.9064 13.6793 23.9417C13.5939 23.977 13.5023 23.9949 13.4099 23.9942C11.7931 23.9989 10.1762 23.9942 8.55938 23.9942C8.53589 23.9909 8.51268 23.9859 8.4899 23.9793L8.49272 5.62704Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.06161 23.9896H4.26172V23.7272C4.26172 19.395 4.26172 15.0628 4.26172 10.7306C4.26172 10.1523 4.52556 9.88708 5.10676 9.88708C5.75368 9.88708 6.4006 9.88708 7.06067 9.88708L7.06161 23.9896Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M2.79614 23.9962C2.07128 23.9962 1.36145 24.0074 0.651617 23.9915C0.264778 23.9821 0.00093893 23.6625 0 23.2416C0 22.3287 0 21.4149 0 20.5019V16.3375C0 15.7873 0.270412 15.5155 0.81593 15.5146C1.47318 15.5146 2.13044 15.5146 2.79708 15.5146L2.79614 23.9962Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M17.5828 8.60939C18.3725 8.61105 19.1542 8.76355 19.883 9.05816C20.6118 9.35278 21.2735 9.78374 21.8304 10.3264C22.3872 10.869 22.8281 11.5127 23.128 12.2206C23.4279 12.9286 23.5809 13.6868 23.5781 14.4521C23.5658 17.6652 20.8667 20.2723 17.5632 20.261C15.9717 20.2542 14.4478 19.636 13.3259 18.542C12.2039 17.4481 11.5754 15.9677 11.5781 14.4254C11.5847 11.2087 14.2757 8.60236 17.5828 8.60939ZM20.8359 12.5499L17.6647 10.6749L14.4935 12.5499V16.2999L17.6647 18.1749L20.8359 16.2999V12.5499Z",
                        fill: "#03F5AE"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M17.7212 12.1945L19.6617 13.3149V15.5556L17.7212 16.6759L15.7807 15.5556V13.3149L17.7212 12.1945Z",
                        fill: "#03F5AE"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_10651_32800",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    }));
};
export default Icon;
